// extracted by mini-css-extract-plugin
export default {"notification":"notification--dMRq2","notificationDescription":"notificationDescription--X1PCk"};